import type { BrandSettingsState } from '../../state';
import findDifference from '~/util/findDifference';

/**
 * Returns the changed fields for brand settings
 * @param {BrandSettingsState} initial
 * @param {BrandSettingsState} updated
 */
const getDifferenceCount = ({
  initial,
  updated,
}: {
  initial: BrandSettingsState;
  updated: BrandSettingsState;
}): { changedPaths: Array<Array<string>>; differenceCount: number } =>
  findDifference({ obj1: initial, obj2: updated });

export default getDifferenceCount;
